export default __webpack_public_path__ + "assets/f02f0537e5ead71b88f7e88ff74258d8.svg";